(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["automated-filling-lines"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.elov-automated-lines').forEach((section) => {
      const routes = section.querySelector('.elov-automated-lines__routes');
      const routeItems = Array.from(section.querySelectorAll('.elov-automated-lines__route'));
      if (!routes || !routeItems.length) return;

      const syncRoute = () => {
        const activeRoute = routeItems.find((route) => route.open);
        routeItems.forEach((route) => route.classList.toggle('is-active', route === activeRoute));
        routes.classList.toggle('has-active-route', Boolean(activeRoute));
      };

      routeItems.forEach((route) => {
        route.addEventListener('toggle', () => {
          if (route.open) {
            routeItems.forEach((otherRoute) => {
              if (otherRoute !== route) otherRoute.open = false;
            });
          }
          syncRoute();
        });
      });

      const hoverQuery = window.matchMedia('(min-width: 901px) and (hover: hover)');
      const nodes = Array.from(section.querySelectorAll('.elov-automated-lines__node'));
      let pinnedNode = null;

      nodes.forEach((node) => {
        const summary = node.querySelector('summary');
        if (!summary) return;

        node.addEventListener('pointerenter', () => {
          if (!hoverQuery.matches || pinnedNode) return;
          node.open = true;
          node.classList.add('is-preview');
        });

        node.addEventListener('pointerleave', () => {
          if (!node.classList.contains('is-preview') || node.classList.contains('is-pinned')) return;
          node.open = false;
          node.classList.remove('is-preview');
        });

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (pinnedNode === node) {
            node.open = false;
            node.classList.remove('is-pinned', 'is-preview');
            pinnedNode = null;
            return;
          }
          if (pinnedNode) {
            pinnedNode.open = false;
            pinnedNode.classList.remove('is-pinned', 'is-preview');
          }
          node.open = true;
          node.classList.remove('is-preview');
          node.classList.add('is-pinned');
          pinnedNode = node;
        });
      });

      syncRoute();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elov-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  class ElovProcessPlayback {
    constructor(container) {
      this.container = container;
      this.tabs = Array.from(container.querySelectorAll('[data-process-tab]'));
      this.panels = Array.from(container.querySelectorAll('[data-process-panel]'));
      this.day = container.querySelector('[data-process-day]');
      this.timer = null;
      this.resumeTimer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', () => this.pauseAt(index));
        tab.addEventListener('pointerleave', () => this.resumeAfterPause());
        tab.addEventListener('focus', () => this.pauseAt(index));
        tab.addEventListener('blur', () => this.resumeAfterPause());
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
      if (!this.reducedMotion) this.start();
    }

    select(index, focusTab) {
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
        panel.classList.toggle('is-active', panelIndex === index);
      });
      this.container.style.setProperty('--process-progress', String(index / (this.tabs.length - 1)));
      this.day.textContent = this.tabs[index].dataset.day;
      if (focusTab) this.tabs[index].focus();
    }

    start() {
      if (this.reducedMotion || this.timer) return;
      this.timer = window.setInterval(() => {
        const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        const index = (current + 1) % this.tabs.length;
        this.select(index, false);
      }, 2400);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseAt(index) {
      window.clearTimeout(this.resumeTimer);
      this.stop();
      this.select(index, false);
    }

    resumeAfterPause() {
      if (this.reducedMotion) return;
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => this.start(), 900);
    }

    onKeydown(event, index) {
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex !== null) {
        event.preventDefault();
        this.stop();
        this.select(nextIndex, true);
      }
    }
  }

  class ElovProcessRoutes {
    constructor(container) {
      this.buttons = Array.from(container.querySelectorAll('[data-process-route-select]'));
      this.panels = Array.from(container.querySelectorAll('[data-process-route-panel]'));
      this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button.dataset.processRouteSelect)));
      this.select('ready-stock');
    }

    select(route) {
      this.buttons.forEach((button) => {
        const selected = button.dataset.processRouteSelect === route;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        const selected = panel.dataset.processRoutePanel === route;
        panel.hidden = !selected;
        const playback = panel.processPlayback;
        if (!playback) return;
        playback.stop();
        playback.select(0, false);
        if (selected) playback.start();
      });
    }
  }

  class ElovTeamCarousel {
    constructor(container) {
      this.container = container;
      this.portraits = Array.from(container.querySelectorAll('[data-team-portrait]'));
      this.roster = Array.from(container.querySelectorAll('.elov-home__team-roster li'));
      this.name = container.querySelector('[data-team-name-output]');
      this.index = container.querySelector('[data-team-index]');
      this.intro = container.querySelector('[data-team-intro-output]');
      this.caseTitle = container.querySelector('[data-team-case-title-output]');
      this.caseCopy = container.querySelector('[data-team-case-copy-output]');
      this.current = 0;
      this.timer = null;
      this.resumeTimer = null;
      this.touchLocked = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.roster.forEach((person, index) => {
        person.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') this.pauseAt(index);
        });
        person.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'touch') this.resumeAfterPause();
        });
        person.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') {
            this.touchLocked = true;
            this.pauseAt(index);
          }
        });
      });
      if (!this.reducedMotion) this.start();
    }

    select(index) {
      this.current = index;
      this.portraits.forEach((portrait, portraitIndex) => portrait.classList.toggle('is-active', portraitIndex === index));
      this.roster.forEach((person, personIndex) => person.classList.toggle('is-active', personIndex === index));
      this.name.textContent = this.portraits[index].dataset.teamName;
      this.index.textContent = String(index + 1).padStart(2, '0');
      this.intro.textContent = this.portraits[index].dataset.teamIntro;
      this.caseTitle.textContent = this.portraits[index].dataset.teamCaseTitle;
      this.caseCopy.textContent = this.portraits[index].dataset.teamCaseCopy;
    }

    start() {
      if (this.reducedMotion || this.timer) return;
      this.timer = window.setInterval(() => this.select((this.current + 1) % this.portraits.length), 3600);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseAt(index) {
      window.clearTimeout(this.resumeTimer);
      this.stop();
      this.select(index);
    }

    resumeAfterPause() {
      if (this.reducedMotion || this.touchLocked) return;
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => this.start(), 700);
    }
  }

  class ElovHeroCarousel {
    constructor(container) {
      this.slides = Array.from(container.querySelectorAll('.elov-home__hero-slide'));
      this.current = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.select(0);
      if (this.slides.length < 2 || this.reducedMotion) return;
      this.start();
    }

    select(index) {
      this.current = index;
      this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      const hero = this.slides[index]?.closest('.elov-home__hero--canton');
      if (hero) hero.classList.toggle('is-canton-active', this.slides[index].hasAttribute('data-canton-slide'));
    }

    start() {
      if (this.timer) return;
      this.timer = window.setInterval(() => this.select((this.current + 1) % this.slides.length), 5000);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  class ElovReadinessCarousel {
    constructor(container) {
      this.slides = Array.from(container.querySelectorAll('.elov-home__readiness-slide'));
      this.current = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2 || this.reducedMotion) return;
      window.setInterval(() => {
        this.current = (this.current + 1) % this.slides.length;
        this.slides.forEach((slide, index) => slide.classList.toggle('is-active', index === this.current));
      }, 5200);
    }
  }

  function addEditableMediaImage(media, source) {
    if (!source) return;
    const image = document.createElement('img');
    image.className = 'elov-home__uploaded-media';
    image.src = source;
    image.alt = '';
    image.loading = 'lazy';
    media.replaceChildren(image);
    media.classList.add('has-upload');
  }

  document.querySelectorAll('[data-elov-process]').forEach((container) => {
    const images = [1, 2, 3, 4, 5, 6, 7].map((index) => container.dataset[`processImage${index}`]);
    container.querySelectorAll('.elov-home__process-panel .elov-home__media').forEach((media, index) => {
      if (!media.hasAttribute('data-preserve-process-media')) addEditableMediaImage(media, images[index]);
    });
    container.processPlayback = new ElovProcessPlayback(container);
  });
  document.querySelectorAll('[data-elov-process-routes]').forEach((container) => new ElovProcessRoutes(container));
  document.querySelectorAll('[data-elov-cases]').forEach((container) => {
    const images = [1, 2, 3].map((index) => container.dataset[`caseImage${index}`]);
    container.querySelectorAll('.elov-home__media').forEach((media, index) => addEditableMediaImage(media, images[index]));
  });
  document.querySelectorAll('[data-elov-team]').forEach((container) => new ElovTeamCarousel(container));
  document.querySelectorAll('[data-elov-hero]').forEach((container) => new ElovHeroCarousel(container));
  document.querySelectorAll('[data-elov-readiness-carousel]').forEach((container) => new ElovReadinessCarousel(container));
  document.querySelectorAll('[data-elov-video-cover]').forEach((cover) => {
    cover.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.className = 'elov-home__video-frame';
      iframe.src = `${cover.dataset.videoUrl}?autoplay=1&rel=0`;
      iframe.title = cover.getAttribute('aria-label');
      iframe.loading = 'eager';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      cover.replaceWith(iframe);
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["factory-tour-dossier"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-elov-tour-video]').forEach((cover) => {
    cover.addEventListener('click', () => {
      const frame = document.createElement('iframe');
      frame.src = cover.dataset.videoUrl;
      frame.title = cover.getAttribute('aria-label').replace('Play ', '');
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.allowFullscreen = true;
      cover.replaceWith(frame);
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overall-process-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (hub) => {
      if (hub.dataset.elovProcessHubReady === 'true') return;
      hub.dataset.elovProcessHubReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      hub.addEventListener('click', (event) => {
        const summary = event.target.closest('.elov-process-hub__module > summary');
        if (!summary || !hub.contains(summary) || reduceMotion.matches) return;

        const module = summary.parentElement;
        if (module.dataset.elovAnimating === 'true') return;

        event.preventDefault();
        module.dataset.elovAnimating = 'true';

        const startHeight = module.getBoundingClientRect().height;
        const duration = 420;
        const easing = 'cubic-bezier(.2,.75,.25,1)';

        const visual = module.querySelector('.elov-process-hub__module-visual');
        const cleanUp = (isClosing, animation) => {
          animation.cancel();
          if (isClosing) {
            visual.style.display = 'none';
            module.open = false;
          }
          module.style.height = '';
          module.style.overflow = '';
          module.dataset.elovAnimating = 'false';
        };

        if (module.open) {
          const endHeight = summary.getBoundingClientRect().height;
          module.style.height = `${startHeight}px`;
          module.style.overflow = 'hidden';
          const animation = module.animate(
            [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
            { duration, easing, fill: 'forwards' }
          );
          animation.onfinish = () => {
            cleanUp(true, animation);
          };
        } else {
          visual.style.display = '';
          visual.style.opacity = '0';
          module.open = true;
          const endHeight = module.getBoundingClientRect().height;
          module.style.height = `${startHeight}px`;
          module.style.overflow = 'hidden';
          requestAnimationFrame(() => {
            visual.style.opacity = '';
          });
          const animation = module.animate(
            [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
            { duration, easing, fill: 'forwards' }
          );
          animation.onfinish = () => {
            cleanUp(false, animation);
          };
        }
      });
    };

    document.querySelectorAll('[data-elov-process-hub]').forEach(initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-development-stage-dossier"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-development-route]').forEach(function (route) {
    var desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    function alignPanelPointer(stage) {
      var panel = stage.querySelector('.elov-development-route__panel');
      var summary = stage.querySelector('summary');
      if (!panel || !summary) return;

      var summaryBox = summary.getBoundingClientRect();
      var stageBox = stage.getBoundingClientRect();
      var nodeCenter = summaryBox.left + (summaryBox.width / 2);
      var isDesktop = window.matchMedia('(min-width: 901px)').matches;
      var panelLeft;
      var panelBox;
      var pointer;

      if (isDesktop) {
        var routeBox = route.getBoundingClientRect();
        var routeCenter = routeBox.left + (routeBox.width / 2);
        var stages = route.querySelectorAll('details');
        var stageIndex = Array.prototype.indexOf.call(stages, stage);
        var isEndpoint = stageIndex === 0 || stageIndex === stages.length - 1;
        var safeInset = 20;
        var desiredPanelLeft;
        var maxPanelLeft;

        panel.style.removeProperty('--panel-width');
        panel.style.removeProperty('--panel-center-offset');
        panel.style.removeProperty('--panel-left');
        panel.style.removeProperty('--panel-translate-x');
        panelBox = panel.getBoundingClientRect();
        maxPanelLeft = Math.max(safeInset, window.innerWidth - panelBox.width - safeInset);
        desiredPanelLeft = (isEndpoint ? nodeCenter : routeCenter) - (panelBox.width / 2);
        panelLeft = Math.max(safeInset, Math.min(maxPanelLeft, desiredPanelLeft));

        panel.style.setProperty('--panel-left', (panelLeft - stageBox.left) + 'px');
        panel.style.setProperty('--panel-translate-x', 'translateX(0)');
      } else {
        panel.style.removeProperty('--panel-center-offset');
        panel.style.removeProperty('--panel-width');
        panel.style.removeProperty('--panel-left');
        panel.style.removeProperty('--panel-translate-x');
        panelBox = panel.getBoundingClientRect();
        panelLeft = (window.innerWidth / 2) - (panelBox.width / 2);
      }

      pointer = nodeCenter - panelLeft;
      pointer = Math.max(26, Math.min(panelBox.width - 26, pointer));
      panel.style.setProperty('--panel-pointer', pointer + 'px');
    }

    route.querySelectorAll('details').forEach(function (stage) {
      stage.addEventListener('mouseenter', function () {
        alignPanelPointer(stage);
        stage.classList.add('is-preview');
        if (desktopHover.matches) {
          stage.setAttribute('open', '');
          window.requestAnimationFrame(function () {
            alignPanelPointer(stage);
          });
        }
      });
      stage.addEventListener('focusin', function () {
        alignPanelPointer(stage);
      });
      stage.addEventListener('mouseleave', function () {
        stage.classList.remove('is-preview');
        if (desktopHover.matches) stage.removeAttribute('open');
      });
      stage.addEventListener('toggle', function () {
        alignPanelPointer(stage);
        if (!stage.open) return;
        route.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== stage) other.removeAttribute('open');
        });
      });
    });

    window.addEventListener('resize', function () {
      route.querySelectorAll('details').forEach(alignPanelPointer);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testing-cycle"] && !Shopify.designMode) return;
  try {
    
  (() => { document.querySelectorAll('.elov-testing-cycle').forEach((section) => { const focus = section.querySelector('.elov-testing-cycle__focus'); const ring = section.querySelector('.elov-testing-cycle__ring'); const nodes = Array.from(section.querySelectorAll('.elov-testing-cycle__node')); if (!focus || !ring || !nodes.length) return; const index = focus.querySelector('.elov-testing-cycle__focus-index'); const title = focus.querySelector('h3'); const values = Array.from(focus.querySelectorAll('dd')); const showGate = () => { nodes.forEach((item) => item.classList.remove('is-active')); focus.classList.add('is-gate'); index.textContent = ''; title.textContent = ''; values.forEach((item) => { item.textContent = ''; }); }; const select = (node) => { nodes.forEach((item) => item.classList.toggle('is-active', item === node)); focus.classList.remove('is-gate'); index.textContent = node.dataset.number; title.textContent = node.dataset.title; values[0].textContent = node.dataset.happens; values[1].textContent = node.dataset.checked; values[2].textContent = node.dataset.recorded; }; nodes.forEach((node) => { node.addEventListener('mouseenter', () => select(node)); node.addEventListener('focus', () => select(node)); node.addEventListener('click', () => select(node)); }); ring.addEventListener('mouseleave', showGate); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testing-sequence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.elov-testing-sequence').forEach((section) => {
      const hoverQuery = window.matchMedia('(min-width: 901px) and (hover: hover)');
      const nodes = Array.from(section.querySelectorAll('.elov-testing-sequence__node'));
      let pinnedNode = null;
      nodes.forEach((node) => {
        const summary = node.querySelector('summary');
        if (!summary) return;
        node.addEventListener('pointerenter', () => { if (!hoverQuery.matches || pinnedNode) return; node.open = true; node.classList.add('is-preview'); });
        node.addEventListener('pointerleave', () => { if (!node.classList.contains('is-preview') || node.classList.contains('is-pinned')) return; node.open = false; node.classList.remove('is-preview'); });
        summary.addEventListener('click', (event) => { event.preventDefault(); if (pinnedNode === node) { node.open = false; node.classList.remove('is-pinned', 'is-preview'); pinnedNode = null; return; } if (pinnedNode) { pinnedNode.open = false; pinnedNode.classList.remove('is-pinned', 'is-preview'); } node.open = true; node.classList.remove('is-preview'); node.classList.add('is-pinned'); pinnedNode = node; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-management-lanes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.elov-production-lanes');

    sections.forEach((section) => {
      const grid = section.querySelector('.elov-production-lanes__grid');
      const lanes = Array.from(section.querySelectorAll('.elov-production-lanes__lane'));
      if (!grid || !lanes.length) return;

      const syncActiveLane = () => {
        const activeLane = lanes.find((lane) => lane.open);
        lanes.forEach((lane) => lane.classList.toggle('is-active', lane === activeLane));
        grid.classList.toggle('has-active-lane', Boolean(activeLane));
      };

      lanes.forEach((lane) => {
        lane.addEventListener('toggle', () => {
          if (lane.open) {
            lanes.forEach((otherLane) => {
              if (otherLane !== lane) otherLane.open = false;
            });
          }
          syncActiveLane();
        });
      });

      const hoverQuery = window.matchMedia('(min-width: 901px) and (hover: hover)');
      const nodes = Array.from(section.querySelectorAll('.elov-production-lanes__node'));
      let pinnedNode = null;

      nodes.forEach((node) => {
        const summary = node.querySelector('summary');
        if (!summary) return;

        node.addEventListener('pointerenter', () => {
          if (!hoverQuery.matches || pinnedNode) return;
          node.open = true;
          node.classList.add('is-preview');
        });

        node.addEventListener('pointerleave', () => {
          if (!node.classList.contains('is-preview') || node.classList.contains('is-pinned')) return;
          node.open = false;
          node.classList.remove('is-preview');
        });

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (pinnedNode === node) {
            node.open = false;
            node.classList.remove('is-pinned', 'is-preview');
            pinnedNode = null;
            return;
          }

          if (pinnedNode) {
            pinnedNode.open = false;
            pinnedNode.classList.remove('is-pinned', 'is-preview');
          }
          node.open = true;
          node.classList.remove('is-preview');
          node.classList.add('is-pinned');
          pinnedNode = node;
        });
      });

      syncActiveLane();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
